import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, Entity, Page, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Event } from '@shapeable/gesda-types';
import { SiteHeaderLayout, ComponentPropsProvider, ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayoutProps, SliceLayoutBoundary, ExplorerTabs, ActiveEntityProvider } from '@shapeable/ui';
import { ExplorerProvider } from '../providers/explorer-provider';
import { EventTabsLayout } from './event-tabs-layout';
import { EventViewLayout } from './event-view-layout';
import { EventMetaLayout } from './event-meta-layout';
import { EVENT_CONTENT_TAB_VIEWS } from '../../types';
import { GESDA_PURPLE_DARK } from '../../theme';
import { useContentView } from '../../hooks/use-content-view';
import { useEventViewDefinition } from '../../hooks/use-event-view-definition';
const cls = classNames('event-explorer-layout');

// -------- Types -------->

// -------- Props -------->

export type EventExplorerLayoutProps = ExplorerEntityDetailsLayoutProps & { 
  entity?: Event;
};

export const EventExplorerLayoutDefaultProps: Omit<EventExplorerLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(4)};
    
    .shp--page-half-banner__title {
      font-family: ${theme.FONT('sans')};
      font-size: 0.75em;
      font-weight: 600;
      color: ${theme.COLOR(GESDA_PURPLE_DARK)};
    }
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    
  `,
});

const TabsStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Tabs: styled(ExplorerTabs)`${TabsStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
  
};

export const EventExplorerLayout: Shapeable.FC<EventExplorerLayoutProps> = (props) => {
  const { className, children, entity } = props;

  const parentEntity = entity as Event & { parent: Entity };
  const { defaultView } = useEventViewDefinition(entity);
  const { activeView, setActiveView, showView } = useContentView(defaultView, EVENT_CONTENT_TAB_VIEWS);

  return (
    <ExplorerProvider>
    <ActiveEntityProvider value={parentEntity.parent}>
    <ComponentPropsProvider value={{
      EntityBanner: {
        variant: 'image',
        showSubheader: true,
        useBackgroundColor: false,
        entityValueProps: { showImage: false, showOutlineNumber: false }
      },
      SessionLayout: {
        showDownloadLinks: false,
      }
    }}>
    <My.Container>
      <My.Header />
      <SliceLayoutBoundary boundary='none' >
      <My.Layout 
        entity={entity}
        className={cls.name(className)}
        stickyTopOffset={64}
        asideMaxWidth={800}
        isAsideSticky={false}
        showAsideHeader={false}
        asideHeaderProps={{
          navigationProps: { showNavigation: false, showIcon: false }
        }}

        // main
        tabs={
          <EventTabsLayout entity={entity} activeView={activeView} setActiveView={setActiveView} />
        }
        content={
          <EventViewLayout entity={entity} showView={showView} />
        }

        showMetaHead={(target) => target === 'aside' || showView('overview')} 
        // aside 
        metaHead={
          <EventMetaLayout entity={entity} />
        }
        />
        </SliceLayoutBoundary>
    </My.Container>
    </ComponentPropsProvider>
    </ActiveEntityProvider>
    </ExplorerProvider>
  )
};

EventExplorerLayout.defaultProps = EventExplorerLayoutDefaultProps;
EventExplorerLayout.cls = cls;